export const PLATFORM = {
  COSMOS: "cosmos",
  MT5: "mt5",
};
